import { CycleLogo, typo } from '@cycle-app/ui';
import styled from 'styled-components';

export const Root = styled.div`
  margin: 24px 47px 77px;
  flex-grow: 1;
  background-color: ${p => p.theme.colors.docPanel.bg};
  border-radius: 12px;
  padding-top: 50px;
  padding-left: 24px;
  padding-right: 24px;
  box-shadow: 0px 1px 5px 1px #0000000D;
`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const StyledCycleLogo = styled(CycleLogo)`
  > svg:last-child {
    color: ${p => p.theme.colors.text.primary};
  }
`;

export const Title = styled.h1`
  ${typo.headerLarge}
  font-size: 62px;
  font-weight: 700;
  text-align: center;
  margin-top: 52px;
  line-height: 82px;
`;

export const Subtitle = styled.h2`
  ${typo.headerLarge}
  font-weight: 500;
  text-align: center;
  margin-top: 40px;
`;

export const SocialContainer = styled.div`
  margin-top: 24px;
  text-align: center;
`;

export const SocialLink = styled.a`
  color: hsl(var(--cycle));
`;

export const ShipPill = styled.div`
  --border: 1px;
  --radius: 12px;
  --bg: linear-gradient(91.49deg, color(display-p3 0.169 0.267 0.906) 11.21%, color(display-p3 0.353 0.431 0.925) 96.17%);
  --borders: linear-gradient(256.91deg, color(display-p3 0.424 0.486 0.918) 11.51%, color(display-p3 0.094 0.196 0.843) 59.43%);
  --shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.15);

  align-items: center;
  color: #FFF;
  display: inline-flex;
  height: 40px;
  justify-content: center;
  transform: rotate(-8.25deg);
  width: 84px;
  position: relative;

  span {
    position: relative;
    z-index: 20;
    font-size: 30px;
    line-height: 30px;
    font-weight: 500;
    transform: translate(0, -2px);
  }

  &::before, &::after {
    border-radius: var(--radius);
    bottom: 0;
    content: "";
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }

  &::before {
    border: var(--border) solid transparent;
    z-index: 3;
    background: var(--bg) padding-box, var(--borders) border-box;
  }

  &::after {
    z-index: 2;
    background: var(--bg);
    box-shadow: var(--shadow);
  }
`;
